import React, { useState, useRef } from 'react';
import InfoTracking from '@app/components/common/InfoTracking';
import { ExclamationCircleFilled, SearchOutlined } from '@ant-design/icons';
import { Divider, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography  } from 'antd';
import {insert, update, dropDetail, getDetailsById, getById} from '../../../../apis/ParametrosApi';
import {getList} from '../../../../apis/PeriodosApi';
import Highlighter from "react-highlight-words";
import Details from './Details'
const { Title } = Typography;
const { Option } = Select;
const { confirm } = Modal;
const App = ({title, id, open, finish}) => {
    const [ form ] = Form.useForm()
    const [tipo, setTipo] = useState("");
    const [ID, setID] = useState(id);
    const [showModal, setShowModal] = useState(false);
    const [dataDetails, setDataDetails] = useState([]);
    const [openNewDetails, setOpenNewDetails] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState(null);
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const [initialValues, setInitialValues] = useState(null);
    const searchInput = useRef(null);
    const [tiposPeriodo, setTiposPeriodo] = useState([]);
    
    const handleOk = async () => {
        const fields = form.getFieldsValue()
        if(ID > 0){
            //Update
            const payload = {
                id: ID,
                activo: true,
                ...fields
            }
            const response = await update(payload);
            if(response.ok){
                message.success('Se actualizó correctamente el periodo!');
            }
        }else{
            //Create
            const payload = {
                id: ID,
                activo: true,
                ...fields
            }
            const response = await insert(payload);
            if(response.ok){
                setID(response.payload);
                
                message.success('Se guardo correctamente el periodo!');
            }
        }
    }

    const onClickNewDetail = ()=>{
        setOpenNewDetails(true);
        setSelectedDetail(null);
    }

    const onClose = ()=>{
        setShowModal(false);
        finish(false);
        setInitialValues(null);
    }

    const finishDetail = async () => {
       setOpenNewDetails(false);
       await refreshDetails();
    }

    React.useEffect(() => {
        setShowModal(open);
    }, [open]);

    const effectRan = useRef(false);
    React.useEffect(() => {

      if (!effectRan.current) {
        (async () => {
          await getCatalogs();
          if(ID > 0){
            refreshData();
          }else{
            setInitialValues({
              descripcion: '',
              clave_sat: '',
            });
          }
        })();
      }
      return () => effectRan.current = true;
    }, [ID]);

    const refreshData = async ()=> {
       await refreshPeriodo();
       await refreshDetails();
    }

    const refreshPeriodo = async ()=> {
        const response = await getById(ID);
        if(response.ok){
          let periodo = response.payload;
          setInitialValues(periodo);
        }
    }

    const refreshDetails = async ()=> {
      const response = await getDetailsById(ID);
      if(response.ok){
        let list = response.payload;
        setDataDetails(list);
      }
    }

    const getCatalogs = async ()=> {
      const responsePeriodos = await getList();
      if(responsePeriodos.ok){
        let items = responsePeriodos.payload;
        setTiposPeriodo(items);
      }
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar la linea del parametro?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: ()=>{deleteOk(item.id)},
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    
    const deleteOk = async (id)=>{
        const response = await dropDetail(id);
        if(response.ok){
            message.success('¡La linea ha sido eliminadó!');
            await refreshDetails();
        }
    }

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };

    const getColumnSearchProps = (dataIndex, text) => ({
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
          close,
        }) => (
          <div
            style={{
              padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <Input
              ref={searchInput}
              placeholder={`Buscar ${text}`}
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{
                marginBottom: 8,
                display: "block",
              }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Buscar
              </Button>
              <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                  width: 90,
                }}
              >
                Limpiar
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  close();
                }}
              >
                cerrar
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined
            style={{
              color: filtered ? "#1677ff" : undefined,
            }}
          />
        ),
        onFilter: (value, record) => {
          if(!record[dataIndex]){return false;}
          return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
        },
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(() => searchInput.current?.select(), 100);
          }
        },
        render: (text) =>
          searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{
                backgroundColor: "#ffc069",
                padding: 0,
              }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ""}
            />
          ) : (
            text
          ),
    });
    
    const columns = [
        {
          title: 'Porcentaje maximo',
          dataIndex: 'porcentaje_maximo',
          key: 'porcentaje_maximo',
        },
        {
          title: 'Incluir neto negativo',
          dataIndex: 'incluir_neto_negativo',
          key: 'incluir_neto_negativo',
          render: (item, object)=> {
            if(item)
              return  <Tag color="green">Si</Tag>;
            else
              return  <Tag color="red">No</Tag>;
          }
        },
        {
          title: 'Valor redondeo neto',
          dataIndex: 'valor_redondeo_neto',
          key: 'valor_redondeo_neto',
        },
        {
          title: 'Llevar saldo redondeo',
          dataIndex: 'llevar_saldo_redondeo',
          key: 'llevar_saldo_redondeo',
          render: (item, object)=> {
            if(item)
              return  <Tag color="green">Si</Tag>;
            else
              return  <Tag color="red">No</Tag>;
          }
        },
        {
          title: 'Aplicar deducciones no descontadas',
          dataIndex: 'aplicar_deducciones_no_descontadas',
          key: 'aplicar_deducciones_no_descontadas',
          render: (item, object)=> {
            if(item)
              return  <Tag color="green">Si</Tag>;
            else
              return  <Tag color="red">No</Tag>;
          }
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, object)=> {
              return <Space>
                <Button type='primary' size='small' onClick={()=>{
                    setOpenNewDetails(true);
                    setSelectedDetail(object);
                }}>Editar</Button>
                <Button type='primary' size='small' danger onClick={()=>{
                    deleteConfirm(object);
                }}>Eliminar</Button>
              </Space>
            }
        }
    ];

    return (
      <Drawer
        title={<>
          { ID > 0 ? '(' + ID + ') ': ''} 
          {title}
        </>}
        width={'100%'}
        placement={"right"}
        onClose={onClose}
        open={open}
        closable={true}
        height={'100%'}
        styles={{
          body: {
            paddingBottom: 80,
          },
        }}
        extra={[
          <Space>
            <Button onClick={onClose}>Cancelar</Button>
            <Button onClick={handleOk} type="primary">
            Guardar
            </Button>
          </Space>
        ]}
      >
        <>
            <div>
                <div style={{float: 'left'}}>
                    <span title=""></span>
                </div>
                <span class="" style={{float:'right'}}>
                </span>
            </div>
            {/* <PageHeader ghost={false} title="Remisiones" extra={[ 
            <Space>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleOk} type="primary">
                Guardar
                </Button>
            </Space>]} />*/}
        {
            initialValues && 
            <Form layout="vertical" form={form} hideRequiredMark initialValues={initialValues} onFinish={handleOk}>
                <Row gutter={16}>
                  <Col md={{span: 12}} sm={{span: 12}} xs={{span: 24}}>
                      <Form.Item
                          name="tipo_periodo"
                          label="Tipo Periodo"
                          rules={[
                          {
                              required: true,
                              message: 'Por favor selecciona un tipo de periodo',
                          },
                          ]}
                      >
                          <Select placeholder="Por favor selecciona un tipo de periodo">
                              {
                                  tiposPeriodo.map((item)=><Option value={item.value}>{item.displayTitle}</Option>)
                              }
                          </Select>
                      </Form.Item>
                  </Col>
                </Row>
            </Form>
        }

        <Divider></Divider>
        <div style={{height: 60}}>
            <div style={{float: 'left'}}>
                <Title level={2}>Líneas de parametro</Title>
            </div>
            <span class="" style={{float:'right'}}>
                <Space>
                    <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button>
                </Space>
            </span>
        </div>
        {
            openNewDetails && 
            <div style={{marginBottom: 10}}>
                {
                    !selectedDetail &&
                    <Details title="Agregar detalle" parametroId={ID} finish={finishDetail} open={openNewDetails}/>
                }
                {
                    selectedDetail &&
                    <Details title="Editar detalle" parametroId={ID} id={selectedDetail.id} finish={finishDetail} open={openNewDetails}/>
                }
            </div>
        }
        {/* <Button disabled={!ID} onClick={onClickNewDetail} type="primary" style={{marginBottom: 10}}>Agregar nuevo detalle</Button> */}
        {
            dataDetails.length === 0 ? <Empty />:
            <Table dataSource={dataDetails} columns={columns} />
        }
        </>
    </Drawer>
  );
};
export default App;